









import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import VChart, { THEME_KEY } from "vue-echarts";

@Component({
  components: {
    VChart
  },
  provide: {
    [THEME_KEY]: "light"
  }
})
export default class extends Mixins() {
  option: any = {
    tooltip: {
      trigger: "axis"
    },
    legend: {
      data: ["C端", "场馆端"]
    },
    xAxis: {
      type: "category",
      data: []
    },
    yAxis: {
      type: "value"
    },
    series: [
      {
        name: "C端",
        type: "line",
        data: []
      },
      {
        name: "场馆端",
        type: "line",
        data: []
      }
    ]
  };

  ei: any = {};

  // echartsTheme: {} = tdTheme;

  async loadData() {
    const res2 = await this.$store.dispatch("statistics/downloadTrendData", {});
    if (res2 && res2.Data) {
      //   console.log(res2.Data);

      this.option.xAxis.data = [];
      this.option.series[0].data = [];
      this.option.series[1].data = [];

      this.option.xAxis.data = res2.Data.categories;

      for (const d of res2.Data.categories) {
        this.option.series[0].data.push(res2.Data.data0[d]);
        this.option.series[1].data.push(res2.Data.data1[d]);
      }

      // console.log(this.option)
    }
  }

  mounted() {
    this.loadData();
  }
}
